import { Box, Tabs, Tab, Chip } from "@mui/material";
import { styled } from "@mui/material/styles";

/**
 * Modern Tab-based Selector Component
 * Clean, visual selection without dropdowns
 */

const StyledTabs = styled(Tabs)(({ theme }) => ({
    borderBottom: '2px solid',
    borderColor: theme.palette.divider,
    '& .MuiTabs-indicator': {
        backgroundColor: theme.palette.primary.main,
        height: 4,
        borderRadius: '4px 4px 0 0',
        boxShadow: theme.palette.mode === 'dark'
            ? '0 -2px 8px rgba(144, 202, 249, 0.5)'
            : '0 -2px 8px rgba(25, 118, 210, 0.4)',
    },
}));

const StyledTab = styled(Tab)(({ theme }) => ({
    textTransform: 'none',
    fontWeight: 500,
    fontSize: '0.95rem',
    minHeight: 48,
    padding: '12px 24px',
    color: theme.palette.text.secondary,
    transition: 'all 0.3s ease',
    borderRadius: '8px 8px 0 0',
    marginRight: '4px',
    '&:hover': {
        color: theme.palette.primary.main,
        backgroundColor: theme.palette.action.hover,
    },
    '&.Mui-selected': {
        color: theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.main,
        fontWeight: 700,
        backgroundColor: theme.palette.mode === 'dark'
            ? 'rgba(144, 202, 249, 0.12)'
            : 'rgba(25, 118, 210, 0.08)',
    },
}));

export default function TabSelector({ items = [], value, setValue, variant = "standard", orientation = "horizontal" }) {
    const handleChange = (event, newValue) => {
        setValue(newValue);
    };

    // Find the index of the current value
    const selectedIndex = items.findIndex(item => item.value === value);

    return (
        <Box sx={{ width: '100%' }}>
            <StyledTabs
                value={selectedIndex !== -1 ? selectedIndex : 0}
                onChange={handleChange}
                variant={variant}
                scrollButtons="auto"
                orientation={orientation}
                sx={{
                    '& .MuiTabs-scrollButtons': {
                        '&.Mui-disabled': { opacity: 0.3 }
                    }
                }}
            >
                {items.map((item, index) => (
                    <StyledTab
                        key={item.value}
                        label={
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                                {item.icon && <Box sx={{ display: 'flex', alignItems: 'center' }}>{item.icon}</Box>}
                                <span>{item.name}</span>
                                {item.badge && (
                                    <Chip
                                        label={item.badge}
                                        size="small"
                                        color="primary"
                                        sx={{ height: 20, fontSize: '0.7rem' }}
                                    />
                                )}
                            </Box>
                        }
                        onClick={() => setValue(item.value)}
                    />
                ))}
            </StyledTabs>
        </Box>
    );
}

